// src/store/useReportStore.ts
import { create } from "zustand";
import api from "../service/api";

interface ReportFilters {
  startDate: string;
  endDate: string;
  warehouseId?: number | string;
  accountId?: number | string;
}

interface ReportStore {
  loading: boolean;
  // Filtreleri burada tutuyoruz ki sayfalar arası geçişte kaybolmasın
  filters: ReportFilters;
  data: {
    stockStatus: any[];
    valuation: any | null;
    aging: any[];
    liquidity: any | null;
    salesPerformance: any[];
  };
  
  // Filtreleri güncellemek için yardımcı fonksiyon
  setFilters: (newFilters: Partial<ReportFilters>) => void;
  // API isteği atarken filtreleri de gönderen yeni fetch fonksiyonu
  fetchReport: (key: keyof ReportStore["data"], endpoint: string) => Promise<void>;
  // Rapor verilerini temizlemek için (isteğe bağlı)
  clearData: (key: keyof ReportStore["data"]) => void;
}

export const useReportStore = create<ReportStore>((set, get) => ({
  loading: false,
  filters: {
    // Varsayılan olarak ayın başından bugüne kadar getirsin
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
    warehouseId: "",
    accountId: ""
  },
  data: {
    stockStatus: [],
    valuation: null,
    aging: [],
    liquidity: null,
    salesPerformance: [],
  },

  setFilters: (newFilters) => 
    set((state) => ({ filters: { ...state.filters, ...newFilters } })),

  fetchReport: async (key, endpoint) => {
    set({ loading: true });
    try {
      // Store'daki güncel filtreleri alıyoruz
      const currentFilters = get().filters;
      
      // API'ye filtreleri query parameter olarak gönderiyoruz
      const res = await api.get(endpoint, { 
        params: currentFilters 
      });

      set((state) => ({
        data: { ...state.data, [key]: res.data },
        loading: false
      }));
    } catch (err) {
      set({ loading: false });
      console.error(`${key} raporu yüklenirken hata oluştu`, err);
    }
  },

  clearData: (key) => 
    set((state) => ({ data: { ...state.data, [key]: Array.isArray(state.data[key]) ? [] : null } }))
}));